import React from 'react';
import { Table } from 'semantic-ui-react';
import MessageCell from '@/components/table/MessageCell';

const RequestAttachmentTransferCell = ({ hide, transferable }) => (
  <>
    {(!hide) && (<MessageCell messageId={`dataset.attachments.transferable.verbose.${transferable}`} />)}
    {(hide) && (<Table.Cell />)}
  </>
);

export default RequestAttachmentTransferCell;
